import { FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import PropTypes from "prop-types";
import Lang from "../../Utils/lang";
import style from "../Form.module.scss";
import { useEffect, useState } from "react";

const lang = Lang.getInstance();

function EnvironmentName({
  systemDataTreatment,
  form,
  setSystemDataTreatment,
  setForm,
}) {
  const [valueRadioButton, setValueRadioButton] = useState("da");
  const [numberAndDate, setNumberAndDate] = useState("");

  /**
   *
   */
  useEffect(() => {
    if (systemDataTreatment.existEnvironmentName) {
      const newVal = systemDataTreatment.existEnvironmentName.split("_");
      setValueRadioButton(newVal[0]);
      if (newVal.length > 1) setNumberAndDate(newVal[1]);
    }
  }, [systemDataTreatment.existEnvironmentName]);

  /**
   *
   * @param {*} e
   * change radio button
   */
  function handleChangeRadioButton(e) {
    let newSystemDataTreatment = Object.assign({}, systemDataTreatment);
    if (e.target.value === "da") {
      setValueRadioButton(e.target.value);
      newSystemDataTreatment.existEnvironmentName = `da_${numberAndDate}`;
      setSystemDataTreatment(newSystemDataTreatment);
      setForm({ ...form, systemDataTreatment: newSystemDataTreatment });
    } else {
      setValueRadioButton(e.target.value);
      newSystemDataTreatment.existEnvironmentName = e.target.value;
      setSystemDataTreatment(newSystemDataTreatment);
      setForm({ ...form, systemDataTreatment: newSystemDataTreatment });
    }
  }

  /**
   *
   * @param {*} e
   * daca este bifat "da" se salveaza si textul din textfield
   */
  function onChange(e) {
    let newSystemDataTreatment = Object.assign({}, systemDataTreatment);
    setNumberAndDate(e.target.value);
    newSystemDataTreatment.existEnvironmentName = `da_${e.target.value}`;
    setSystemDataTreatment(newSystemDataTreatment);
    setForm({ ...form, systemDataTreatment: newSystemDataTreatment });
  }

  return (
    <>
      <FormLabel className={style.formLabel}>
        Există o autorizație de mediu?
      </FormLabel>
      <RadioGroup
        value={valueRadioButton}
        onChange={handleChangeRadioButton}
        style={{ marginLeft: 15 }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel value="da" control={<Radio />} label="Da" />
          <TextValidator
            label="Număr și dată"
            type="text"
            name="existEnvironmentName"
            variant="standard"
            fullWidth
            onChange={(e) => onChange(e)}
            disabled={valueRadioButton === "da" ? false : true}
            value={numberAndDate}
            validators={valueRadioButton === "da" ? ["required"] : []}
            errorMessages={
              valueRadioButton === "da" ? [lang.get("textFieldRequired")] : []
            }
            style={{ marginLeft: 10, verticalAlign: "middle" }}
          />
        </div>
        <FormControlLabel value="nu" control={<Radio />} label="Nu" />
      </RadioGroup>
    </>
  );
}

export default EnvironmentName;
EnvironmentName.propTypes = {
  systemDataTreatment: PropTypes.object,
  form: PropTypes.object,
  setSystemDataTreatment: PropTypes.func,
  setForm: PropTypes.func,
};
